<template>
    <div>  
    </div>
</template>


<script type = "text/javascript" >

import { container } from '../../services/container'

export default {

    data () {
        return {
        }
    },

    computed: {
        user () {
            return this.$root.user
        },
    },
    mounted () {
        if (this.user && this.user.source === 'default') {
            this.$router.push('/checkout/scegli-ricette')
            return;
        }  

        let param = this.$route.params.source;

        container.get('services.cookies').set('user_source_track', param);
        container.get('source').updateValue(param);

        this.$router.push('/checkout/scegli-ricette')
        
    }
}

</script>